import { Injectable } from '@angular/core';
import { Route, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { envAccess, environments } from '@sd-portal/shared/functions';

/**
 * NOTE: this is a temp. solution to actual feature toggles
 * please replace when full implementaion has been developed
 */
@Injectable()
export class EnvFeatureToggleGuard {
  constructor(private readonly router: Router) {}

  canLoad(route: Route): Observable<boolean> {
    return this.canUseRoute(route);
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canUseRoute(route);
  }

  private canUseRoute(route: Route | ActivatedRouteSnapshot): Observable<boolean> {
    let envToggle: environments = null;
    let envRedirect = '/';

    if (route && route.data) {
      envToggle = route.data['envToggle'];
      envRedirect = route.data['envRedirect'];
    }

    const allowed = envAccess(envToggle);

    if (!allowed) {
      this.router.navigate([envRedirect]);
    }

    return of(allowed);
  }
}
